import { render, staticRenderFns } from "./pcInfo.vue?vue&type=template&id=6caa67b2"
import script from "./pcInfo.vue?vue&type=script&lang=js"
export * from "./pcInfo.vue?vue&type=script&lang=js"
import style0 from "./pcInfo.vue?vue&type=style&index=0&id=6caa67b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports